import React, { useState } from "react";
import "./services.css";

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What i offer</span>

      <div className="services__container container grid">
        <div className="services__content">
          <div>
            {/* <i className="uil uil-web-grid services__icon"></i> */}
            <i class="bx bx-window-alt services__icon"></i>
            <h3 className="services__title">Website design and development</h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(1)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div
            className={
              toggleState === 1
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>
              <h3 className="services__modal-title">
                Website design and development
              </h3>
              {/* <p className="services__modal-description">
                Service with a 1 year experience. Providing quality work to
                clients and companies.
              </p> */}

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Collaborating with clients to understand their business
                    goals and design preferences
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Creating wireframes and prototypes to visualize the layout
                    and functionality of the website
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Developing responsive, mobile-friendly websites using HTML,
                    CSS, and JavaScript
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Implementing interactive elements such as forms, galleries,
                    and animations to enhance the user experience
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Testing and debugging the website to ensure it functions
                    properly across different devices and browsers
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services__content">
          <div>
            <i className="uil uil-arrow services__icon"></i>
            <h3 className="services__title">Responsive design</h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(2)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div
            className={
              toggleState === 2
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>
              <h3 className="services__modal-title">Responsive design</h3>
              {/* <p className="services__modal-description">
                Service with a 1 year experience. Providing quality work to
                clients and companies.
              </p> */}

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Creating layouts that adapt to different screen sizes and
                    resolutions
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Using media queries to control how elements are displayed on
                    different devices
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Ensuring that the website's content is easily readable and
                    accessible on all devices
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Testing the website on multiple devices and browsers to
                    ensure it looks and functions as intended
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Using responsive design techniques to optimize the website's
                    performance on mobile devices
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services__content">
          <div>
            <i className="uil uil-edit services__icon"></i>
            <h3 className="services__title">UI / UX Design</h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(3)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div
            className={
              toggleState === 3
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>
              <h3 className="services__modal-title"> UI / UX Design</h3>
              {/* <p className="services__modal-description">
                Service with a 1 year experience. Providing quality work to
                clients and companies.
              </p> */}

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Collaborating with clients and design teams to understand
                    user needs and create intuitive interfaces
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Creating wireframes, prototypes, and high-fidelity mockups
                    to visualize the layout and functionality of the interface
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Using design software such as Adobe Creative Suite or Figma
                    to create visual assets and layouts
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Conducting user testing to gather feedback and iterate on
                    the design
                  </p>
                </li>

                <li className="services__modal-service">
                  <p className="services__modal-info">
                    <i className="uil uil-check-circle services__modal-icon"></i>
                    Ensuring that the interface is visually appealing and
                    consistent with the client's branding guidelines
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
